import { List } from 'immutable';

import FirstLandModal from 'features/onboarding/FirstLandModal';

const DEFAULT_EMPLOYEE = { name: '', default_role_name: '', level: 'Employee' };

export const SEGMENTED_ONBOARDING_DEFAULTS = {
  employees: {
    collection: List([DEFAULT_EMPLOYEE, DEFAULT_EMPLOYEE]),
    roles: [],
  },
  schedule: {
    startOfWeek: 1,
    openTime: 7,
    closingTime: 22,
    smsNotifySchedule: true,
  },
  getMobileApp: {
    sendSms: true,
    phone: null,
  },
  scheduleSettings: {
    resetTime: 0,
    startOfWeek: 1,
  },
};

export const SEGMENTED_ONBOARDING_MODALS = {
  default: {
    steps: [FirstLandModal],
  },
};
